<div *ngIf="model" class="np-form-control dx-fieldset mainInfos buyer-form">
  <div class="container-fluid px-0">
    <div class="row g-3">
      <!-- Zeile 1: Name | Kennung -->
      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Name' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.buyerName"
              [readOnly]="readOnlyUser('buyerName')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Kennung' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.buyerId"
              [readOnly]="readOnlyUser('buyerId')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <!-- Zeile 2: Ansprechpartner | Typ-ID -->
      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Ansprechpartner' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.contact"
              [readOnly]="readOnlyUser('buyerAddressContact')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Typ-ID' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-autocomplete
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model?.buyer.buyerIdType"
              [dataSource]="idType"
              [minSearchLength]="0"
              [readOnly]="readOnlyUser('buyerIdType')"
              [showClearButton]="true"
              [showDropDownButton]="true"
              valueChangeEvent="focusout">
            </dx-autocomplete>
          </div>
        </div>
      </div>

      <!-- Adresszusätze: direkt nach oben, volle Breite, Felder sofort sichtbar -->
      <div class="col-12">
        <div class="buyer-address-additions">
          <dx-accordion
            [collapsible]="true"
            [multiple]="false"
            [selectedIndex]="0"
            [animationDuration]="150">
            <dxi-item title="{{ 'Adresszusätze' | translate }}">
              <div class="row g-3">
                <div class="col-12">
                  <div class="dx-field">
                    <div class="dx-field-label dx-field-label200">{{ 'Zusatz 1' | translate }}</div>
                    <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                      <dx-text-box
                        (onValueChanged)="catalogChanged($event)"
                        [(value)]="model.buyer.address.name1"
                        [readOnly]="readOnlyUser('buyerAddressName1')"
                        [showClearButton]="true"
                        valueChangeEvent="focusout">
                      </dx-text-box>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="dx-field">
                    <div class="dx-field-label dx-field-label200">{{ 'Zusatz 2' | translate }}</div>
                    <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                      <dx-text-box
                        (onValueChanged)="catalogChanged($event)"
                        [(value)]="model.buyer.address.name2"
                        [readOnly]="readOnlyUser('buyerAddressName2')"
                        [showClearButton]="true"
                        valueChangeEvent="focusout">
                      </dx-text-box>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="dx-field">
                    <div class="dx-field-label dx-field-label200">{{ 'Zusatz 3' | translate }}</div>
                    <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                      <dx-text-box
                        (onValueChanged)="catalogChanged($event)"
                        [(value)]="model.buyer.address.name3"
                        [readOnly]="readOnlyUser('buyerAddressName3')"
                        [showClearButton]="true"
                        valueChangeEvent="focusout">
                      </dx-text-box>
                    </div>
                  </div>
                </div>
              </div>
            </dxi-item>
          </dx-accordion>
        </div>
      </div>

      <!-- Adresse -->
      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Straße / Nr.' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.street"
              [readOnly]="readOnlyUser('buyerAddressStreet')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'PLZ' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.zip"
              [readOnly]="readOnlyUser('buyerAddressZip')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Bundesland' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.state"
              [readOnly]="readOnlyUser('buyerAddressState')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Ort' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.city"
              [readOnly]="readOnlyUser('buyerAddressCity')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Land' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.country"
              [readOnly]="readOnlyUser('buyerAddressCountry')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Telefon' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.phone"
              [readOnly]="readOnlyUser('buyerAddressPhone')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Telefax' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.fax"
              [readOnly]="readOnlyUser('buyerAddressFax')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'E-Mail' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.email"
              [readOnly]="readOnlyUser('buyerAddressEmail')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Homepage' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-box
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.url"
              [readOnly]="readOnlyUser('buyerAddressUrl')"
              [showClearButton]="true"
              valueChangeEvent="focusout">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="dx-field">
          <div class="dx-field-label dx-field-label200">{{ 'Bemerkungen' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <dx-text-area
              (onValueChanged)="catalogChanged($event)"
              [(value)]="model.buyer.address.addressRemarks"
              [readOnly]="readOnlyUser('buyerAddressRemarks')"
              [autoResizeEnabled]="false"
              [height]="120"
              valueChangeEvent="focusout">
            </dx-text-area>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
